export default {
    path: '',
    component: () => import(`@/page/distributor/component/noLogin-layout/1.0.0/index.vue`),
    children: [
        {
            path: '/distributor/FAQ',
            name: 'distributor-FAQ',
            component: () => import('./index.vue'),
            meta: {
                skip_check_token: true,
            }
        },
    ]
};
